var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGroupBy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.916,
    height: 11.804,
    viewBox: "0 0 13.916 11.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_list-view",
    d: "M5.386,20.118l-2.151.015v-1.8l2.151-.015Zm11.75,2.687H6.846V21.022H17.136Zm0-2.687H6.846V18.335H17.136ZM5.4,12.784,3.324,12.8V11.016L5.4,11Zm11.742,2.743H6.862V13.744H17.143Zm.008-2.743H6.862V11H17.151Z",
    transform: "translate(-3.235 -11.001)",
    fill: "#7a7a7a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroupBy);
export default __webpack_public_path__ + "static/media/icon_group-by.00dac837.svg";
export { ForwardRef as ReactComponent };